import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user.component';
import { UserNewDealComponent } from '@accounts/user/pages/user-new-deal/user-new-deal.component';
import { UserNewPickTrailerMapComponent } from '@accounts/user/pages/user-new-pick-trailer-map/user-new-pick-trailer-map.component';
import { UserActiveDealsComponent } from '@accounts/user/pages/user-active-deals/user-active-deals.component';
import { UserPersonalDataComponent } from '@accounts/user/pages/user-personal-data/user-personal-data.component';
import { UserArchiveDealsComponent } from '@accounts/user/pages/user-archive-deals/user-archive-deals.component';
import {UserInfoComponent} from "@accounts/user/pages/user-info/user-info.component";
import {SupportComponent} from "@accounts/user/pages/support/support.component";
import { OrderCardDetailsComponent } from './components/order-card-details/order-card-details.component';
import { RentalDetailComponent } from './pages/rental-detail/rental-detail.component';
import { PdfViewerPageComponent } from '@ui/pdf-viewer-page/pdf-viewer-page.component';
import { UserService } from '@core/auth';
const routes: Routes = [
  {
    path: '',
    component: UserComponent,
    children: [
      {
        path: 'new',
        children: [
          {
            path: '',
            component: UserNewPickTrailerMapComponent,
          },
          {
            path: ':stationId',
            component: UserNewPickTrailerMapComponent
          },
          {
            path: ':stationId/:trailerId',
            component: UserNewDealComponent
          },
          {
            path: ':stationId/:trailerId/:returnStationId',
            component: UserNewDealComponent,
          },
          {
            path: ':stationId/:trailerId/:returnStationId/:tariffId',
            component: UserNewDealComponent,
          },
          {
            path: ':stationId/:trailerId/:returnStationId/:tariffId/:rentDays',
            component: UserNewDealComponent,
          },
        ]
      },
      {
        path: 'active',
        children: [
          {
            path: '',
            component: UserActiveDealsComponent
          },
          {
            path: ':id',
            component: OrderCardDetailsComponent
          }
        ]
      },
      {
        path: 'in-rent',
        component: RentalDetailComponent
      },
      {
        path: 'personal-data',
        component: UserPersonalDataComponent
      },
      {
        path: 'archive',
        children: [
          {
            path: '',
            component: UserArchiveDealsComponent
          },
          {
            path: ':id',
            component: OrderCardDetailsComponent
          }
        ]
      },
      {
        path: '',
        redirectTo: '/cabinet/new',
        pathMatch: 'full'
      },
      {
        path: 'user-info',
        component: UserInfoComponent
      },
      {
        path: 'rental-detail',
        component: RentalDetailComponent
      },
      {
        path: 'support',
        component: SupportComponent
      },
      {
        path: 'pdf',
        component: PdfViewerPageComponent
      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
